import React from 'react';
import PropTypes from 'prop-types';

const PageHasBeenForceRefreshed = 'page-has-been-force-refreshed';

const retryPageLoading = () => {
  const pageHasAlreadyBeenForceRefreshed = JSON.parse(
    window.sessionStorage.getItem(PageHasBeenForceRefreshed) || 'false',
  );

  if (!pageHasAlreadyBeenForceRefreshed) {
    window.sessionStorage.setItem(PageHasBeenForceRefreshed, 'true');
    window.location.reload();
  } else {
    window.sessionStorage.setItem(PageHasBeenForceRefreshed, 'false');
  }
};

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch() {
    retryPageLoading();
    this.setState({ hasError: true });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return <>Please retry again after 5 mins</>;
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.element.isRequired,
};
